import { useLingui } from '@lingui/react/macro';

import { ConfirmDialog } from '#features/ui';
import { useNativeIosBack } from '../../hooks/useNativeIosBack';

export const NativeIosBack = () => {
  const { t } = useLingui();
  const back = useNativeIosBack();
  return (
    <ConfirmDialog
      open={back.pending}
      title={t`Leave without saving?`}
      description={t`Your unsaved changes will be lost.`}
      cancelLabel={t`Stay`}
      confirmLabel={t`Leave`}
      onCancel={back.cancel}
      onConfirm={back.confirm}
    />
  );
};
